__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@mulesoft/exchange-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mulesoft/api-console-components-pre", "6.6.76", () => (() => (__webpack_require__(419))), 1);
			register("@mulesoft/api-console-components", "6.6.76", () => (() => (__webpack_require__(222))), 1);
			register("@mulesoft/exchange-react-hooks", "5.4.64", () => (() => (__webpack_require__(258))), 1);
			register("@mulesoft/exchange-ui-components", "5.4.64", () => (() => (__webpack_require__(1101))), 1);
			register("@mulesoft/exchange-ui-portals-common", "0.12.328", () => (() => (__webpack_require__(741))), 1);
			register("@mulesoft/exchange-ui-portals-store", "0.12.328", () => (() => (__webpack_require__(745))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(515))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(384))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(575))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};